import React, { useState } from "react";
import { Lock, ShieldCheck, Loader2 } from "lucide-react";
import { STRIPE_PAYMENT_LINK } from "../../config";

export default function PaymentStep() {
  const [loading, setLoading] = useState(false);

  const onPay = () => {
    setLoading(true);
    window.location.href = STRIPE_PAYMENT_LINK;
  };

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          Approve & publish
        </h2>
        <p className="text-slate-500 mt-2">
          You only pay after reviewing and approving your setup. One time, no subscription.
        </p>
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white overflow-hidden">
        <div className="p-6 bg-gradient-to-br from-blue-50/60 to-emerald-50/60">
          <div className="flex items-baseline gap-2">
            <span className="font-heading text-5xl font-semibold text-slate-900">$9.99</span>
            <span className="text-slate-500 text-sm">one-time</span>
          </div>
          <div className="text-sm text-slate-600 mt-1">Gigma Setup Approval</div>
        </div>

        <ul className="px-6 py-5 space-y-3 text-sm text-slate-700">
          {[
            "Interactive Publish Assistant — your answers follow you with one-tap Copy buttons",
            "Auto-written description & verification guide",
            "Lifetime access to your finalized profile & roadmap",
          ].map((line) => (
            <li key={line} className="flex items-start gap-2.5">
              <span className="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center text-xs shrink-0 mt-0.5">✓</span>
              {line}
            </li>
          ))}
        </ul>

        <div className="px-6 pb-6">
          <button
            data-testid="pay-button"
            onClick={onPay}
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 text-white rounded-full px-6 py-3.5 font-medium hover:-translate-y-0.5 transition-transform disabled:opacity-60 disabled:hover:translate-y-0"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" /> Redirecting to secure checkout…
              </>
            ) : (
              <>
                <Lock className="w-4 h-4" /> Pay $9.99 & Approve
              </>
            )}
          </button>
          <div className="flex items-center justify-center gap-1.5 text-xs text-slate-400 mt-3">
            <ShieldCheck className="w-3.5 h-3.5" /> Payments handled securely by Stripe
          </div>
        </div>
      </div>
    </div>
  );
}
